import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { LoadingSpinnerWithContent } from '../../components/LoadingSpinnerWithContent/LoadingSpinnerWithContent';
import { useStore } from '../../hooks/use-store';

const DashboardStub = observer(() => {
  const { dashboardStubStore: store, apiStore } = useStore();

  useEffect(() => {
    if (apiStore.isAuthenticated) {
      if (store.sapId) {
        void store.init();
      }
    }
  }, [store, store.sapId, apiStore.isAuthenticated]);

  return (
    <LoadingSpinnerWithContent size='large'>
      One moment while we retrieve your practice information
    </LoadingSpinnerWithContent>
  );
});

export default DashboardStub;
